import { HeaderCurrencyInfo, NewLanguageInfo, NewMemberLoginData, type CurrencyListObj } from '@/logic/header/model';
import { setEmailFun, setServicePhoneFun, setWorkTimeFun } from '@/store/order';
import { setSuggestRouteFun, setHotTicketFun } from '@/store/home';
import type { HotTicketItem, SuggestRouteItem } from '#/home';
import { setHotCityFun } from '@/store/locale';
export interface CurrencyListAo {
	defaultCurrency: string;
	datas: CurrencyListObj[];
}
export interface GlobaSetObjAo {
	code: string;
	desc: string;
	icon: string;
}
export interface GlobaSetAo {
	siteLanguage: GlobaSetObjAo[];
	aboutUs?: any;
	telephone: string;
	workTime: string;
	email: string;
	suggestRoute: SuggestRouteItem[];
	hotTicket: HotTicketItem[];
	hotCity: any[];
}

export interface MemberLoginAo {
	gender: string;
	token: string;
	uid: string;
	uname: string;
	email: string;
}
export interface RegisterFormAo {
	email: string;
	password: string;
}
export const convertCurrencyListAoToLo = (currencyListAo: CurrencyListAo) => {
	const currencyListData = new HeaderCurrencyInfo();
	currencyListData.selectCurrency = currencyListAo.defaultCurrency;
	currencyListData.currencyList = currencyListAo.datas;
	return currencyListData;
};
export const convertGlobalSetAoToLo = (globalSetAo: GlobaSetAo) => {
	const languageLisData = new NewLanguageInfo();
	const servicePhone = globalSetAo?.telephone;
	const workTime = globalSetAo?.workTime;
	const email = globalSetAo?.email;
	const suggestRoute = globalSetAo?.suggestRoute;
	const hotTicket = globalSetAo?.hotTicket;
	const hotCity = globalSetAo?.hotCity;
	setServicePhoneFun(servicePhone);
	setWorkTimeFun(workTime);
	setEmailFun(email);
	setSuggestRouteFun(suggestRoute);
	setHotTicketFun(hotTicket);
	setHotCityFun(hotCity);
	languageLisData.languageList = globalSetAo?.siteLanguage;
	return languageLisData;
};

export const convertMemberLoginAoToLo = (memberLoginAo: MemberLoginAo) => {
	const memberLoginData = new NewMemberLoginData();
	memberLoginData.gender = memberLoginAo.gender;
	memberLoginData.token = memberLoginAo.token;
	memberLoginData.userId = memberLoginAo.uid;
	memberLoginData.uname = memberLoginAo.uname;
	memberLoginData.email = memberLoginAo.email;
	return memberLoginData;
};


